import type {
  CoreBookingProduct,
  CoreInsuranceQuoteResponseList,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get insurance quotes for booking items by its ID.
 *
 * @endpoint GET /api/saas/me/bookings/{bookingId}/insurances/quote
 * @scope saas
 * @see https://flecto.dev/api-4724216
 */
export async function getAllBookingInsurancesQuote(
  bookingId: ParameterID,
  options?: GetAllBookingInsurancesQuoteOptions
): Promise<CoreInsuranceQuoteResponseList> {
  const params = new URLSearchParams()

  options?.booking_items?.forEach((record) => {
    params.append('booking_items[][id]', String(record.id))
    params.append('booking_items[][quantity]', String(record.quantity))
  })

  if (options?.at_pickup) {
    params.append('at_pickup', String(options?.at_pickup))
  }

  if (options?.end_at) {
    params.append('end_at', String(options?.end_at))
  }

  const [resQuotes] = await Promise.all([
    api.get(`/api/saas/me/bookings/${bookingId}/insurances/quote`, { params }),
  ])

  return resQuotes.data
}

export type GetAllBookingInsurancesQuoteOptions = {
  booking_items?: Pick<CoreBookingProduct, 'id' | 'quantity'>[]
  at_pickup?: boolean
  end_at?: string
}
